import { render, staticRenderFns } from "./index-secondary.vue?vue&type=template&id=51f427bf&scoped=true&"
import script from "./index-secondary.vue?vue&type=script&lang=js&"
export * from "./index-secondary.vue?vue&type=script&lang=js&"
import style0 from "./index-secondary.vue?vue&type=style&index=0&id=51f427bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f427bf",
  null
  
)

export default component.exports